import { render, staticRenderFns } from "./Page02New.vue?vue&type=template&id=524d7a5e&"
import script from "./Page02New.vue?vue&type=script&lang=js&"
export * from "./Page02New.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QBtn,QSelect,QIcon,QInput,QPopupProxy,QDate,QCircularProgress,QTooltip,QMarkupTable,QTable,QTd,QDialog,QCard,QCardSection,QCheckbox,QInnerLoading,QSpinnerGears,ClosePopup} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QSpace,QBtn,QSelect,QIcon,QInput,QPopupProxy,QDate,QCircularProgress,QTooltip,QMarkupTable,QTable,QTd,QDialog,QCard,QCardSection,QCheckbox,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
